export interface ImageSizing {
  width?: number;
  aspectRatio?: string;
}

export type ImageTransform = (src: string, sizing?: ImageSizing) => string;

export const CARD_IMAGE_SIZING: ImageSizing = { width: 600, aspectRatio: '6:4' };
